// src/components/ProductsSection.jsx

import React from "react";
import products from "../../data/productsList";
import "../../styles/Products.css";

export default function Products() {
  return (
    <section id="products" className="products-section">
      <h2 className="products-title">Realize Your Ideas With Us</h2>
      <div className="products-grid">
        {products.map((product, index) => (
          <div
            className="product-card"
            key={index}
            style={{ backgroundImage: `url(${product.img})` }}
          >
            <div className="product-overlay">
              <h3>{product.name}</h3>
              <ul>
                {product.description.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
